import { useState } from "react";
import axiosInstance from "../../api/axios";
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import { setUpdateAvatar } from "../../store/api/authSlice";
import { RECAPTCHA_SITE_KEY } from "../helpers";

interface UseUploadPhotoReturn {
  uploadPhoto: (file: File) => void;
  isLoading: boolean;
  error: string | null;
}

export const useUploadPhoto = (): UseUploadPhotoReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const dispatch = useDispatch();

  const uploadPhoto = (file: File) => {
    setIsLoading(true);
    setError(null);

    try {
      if (!window.grecaptcha || !window.grecaptcha.enterprise) {
        return;
      }
      window.grecaptcha.enterprise.ready(async () => {
        const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: "submit" });
        console.log("Получен reCAPTCHA token:", token);

        const formData = new FormData();
        formData.append("picture", file);
        formData.append("g-recaptcha-response", token);

        const response = await axiosInstance.post("user/picture/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        dispatch(setUpdateAvatar(response.data.picture));
        if (!response.status) {
          throw new Error(`Ошибка загрузки: ${response.statusText}`);
        }

        console.log("Успешно загружено:", response);

        return { success: true, data: response };
      });
    } catch (err: any) {
      console.error("Ошибка при загрузке фото:", err);
      setError(err.message || "Ошибка загрузки");
      return { success: false, error: err.message || "Ошибка загрузки" };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    uploadPhoto,
    isLoading,
    error,
  };
};
